/* import __COLOCATED_TEMPLATE__ from './branching-qualification.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();